export const PRODUCER_LIST = 'PRODUCER_LIST';
export const PRODUCER_CREATE = 'PRODUCER_CREATE';
export const PRODUCER_READ = 'PRODUCER_READ';
export const PRODUCER_UPDATE = 'PRODUCER_UPDATE';
export const PRODUCER_DELETE = 'PRODUCER_DELETE';
